<template>
  <v-col cols="12">
    <v-form>
      <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
        <v-snackbar
          v-model="companyInfosIsUpdated"
          elevation="24"
          color="green darken-3"
          bottom
          right
        >
          <span class="text-subtitle-1">
            Les informations de l'entreprise ont bien été mises à jour.
          </span>
          <template v-slot:action="{ attrs }">
            <v-btn
              color="black"
              text
              v-bind="attrs"
              @click="companyInfosIsUpdated = false"
            >
              Fermer
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarFailed"
          rounded="pill"
          elevation="24"
          color="red darken-3"
          width="100%"
        >
          <span class="text-subtitle-1">
            {{ snackbarFailedMessage.split(":")[1] }}
            {{ snackbarFailedMessage1 }}
          </span>
          <template v-slot:action="{ attrs }">
            <v-btn
              color="black"
              text
              v-bind="attrs"
              @click="snackbarFailed = false"
            >
              Fermer
            </v-btn>
          </template>
        </v-snackbar>

        <v-alert
          outlined
          type="error"
          prominent
          border="left"
          style="margin-top: 1em"
          v-if="formErrors.length > 0"
        >
          <b>Veuillez corriger les erreurs suivantes:</b>
          <ul>
            <li v-for="(error, index) in formErrors" :key="index">
              • {{ error }}
            </li>
          </ul>
        </v-alert>

        <v-card color="white" dark class="rounded-xl">
          <v-card-title class="text-h5" style="color: #6b6868">
            <v-icon style="padding-right: 0.3em; color: #6b6868"
              >mdi-information-outline
            </v-icon>
            À propos de l'entreprise
          </v-card-title>

          <v-card-text>
            <section
              style="
                background: rgba(255, 255, 255, 0.9);
                color: #777171;
                padding: 1em;
              "
            >
              <v-row class="pa-5">
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Nom de l'entreprise"
                    v-model="formFields.companyName"
                    required
                    prepend-inner-icon="mdi-ab-testing"
                    light
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Site de l'entreprise"
                    v-model="formFields.websiteUrl"
                    placeholder="www.employeur.fr"
                    prepend-inner-icon="mdi-web"
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-autocomplete
                    label="Taille de l'entreprise"
                    v-model="formFields.companySize"
                    prepend-inner-icon="mdi-account-group-outline"
                    light
                    :items="companySizeItems"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-autocomplete
                    label="Secteur d'activité"
                    id="companyActivitySector"
                    name="companyActivitySector"
                    v-model="formFields.companyActivitySector"
                    item-text="name"
                    item-value="id"
                    :items="activitySectorItems"
                    prepend-inner-icon="mdi-domain-plus"
                    light
                    required
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    v-model="formFields.creationDate"
                    label="Année de création"
                    ref="picker"
                    light
                    type="number"
                    min="1900"
                    max="2099"
                    step="1"
                    :placeholder="currentYear"
                    prepend-inner-icon="mdi-calendar"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Contact téléphonique"
                    v-model="formFields.phoneNumber"
                    placeholder="Ex: 624 99 99 99"
                    prepend-inner-icon="mdi-cellphone-sound"
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-6" style="margin-top: -2em">
                  <v-row>
                    <v-file-input
                      v-model="formFields.logo"
                      truncate-length="30"
                      placeholder="Ajouter / Remplacer le logo"
                      prepend-icon="mdi-camera-image"
                      show-size
                      light
                      accept="image/*"
                    >
                      <template v-slot:selection="{ text }">
                        <v-chip small label color="primary">
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-row>
                </v-col>

                <v-col cols="12" md="6" class="pa-6" style="margin-top: -2em">
                  <v-row>
                    <v-file-input
                      v-model="formFields.backgroundPicture"
                      truncate-length="30"
                      placeholder="Ajouter / Remplacer la photo de couverture"
                      prepend-icon="mdi-tooltip-image-outline"
                      show-size
                      light
                      accept="image/*"
                    >
                      <template v-slot:selection="{ text }">
                        <v-chip small label color="primary">
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-row>
                </v-col>
              </v-row>
            </section>
          </v-card-text>
        </v-card>
        <v-card color="white" dark class="rounded-xl" style="margin-top: 3em">
          <v-card-title class="text-h5" style="color: #6b6868">
            <v-icon style="padding-right: 0.3em; color: #6b6868"
              >mdi-script-text-outline
            </v-icon>
            Présentation de l'entreprise
          </v-card-title>

          <v-card-text>
            <section
              style="
                background: rgba(255, 255, 255, 0.9);
                color: #777171;
                padding: 1em;
              "
            >
              <v-row class="pa-5">
                <h5>Présentez votre entreprise</h5>
                <v-col cols="12">
                  <editor
                    api-key="tengbryysq97t0kqjj6qhj25ssgheorm0nv6m0vf8aev6s9z"
                    v-model="formFields.description"
                    :init="{
                      height: 250,
                      menubar: true,
                      language: 'fr_FR',
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                                 alignleft aligncenter alignright alignjustify | \
                                 bullist numlist outdent indent | removeformat | help',
                    }"
                  />
                </v-col>
              </v-row>
            </section>
            <section
              style="
                background: rgba(255, 255, 255, 0.9);
                color: #777171;
                padding: 1em;
              "
            >
              <v-row class="pa-5">
                <h5>Pourquoi postuler dans votre entreprise ?</h5>
                <v-col cols="12">
                  <editor
                    v-model="formFields.whyToApply"
                    api-key="tengbryysq97t0kqjj6qhj25ssgheorm0nv6m0vf8aev6s9z"
                    :init="{
                      height: 250,
                      menubar: true,
                      language: 'fr_FR',
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                                 alignleft aligncenter alignright alignjustify | \
                                 bullist numlist outdent indent | removeformat | help',
                    }"
                  />
                </v-col>
              </v-row>
            </section>
          </v-card-text>
        </v-card>

        <v-row class="mt-6">
          <v-col cols="12" offset-md="4" md="4" sm="12" xs="12">
            <v-btn
              class="col-12"
              color="success"
              rounded
              v-on:click="updateCompanyInfos"
            >
              <v-icon left> mdi-content-save-all-outline</v-icon>
              Enregistrer
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-form>
  </v-col>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";
import Editor from "@tinymce/tinymce-vue";

export default Vue.extend({
  name: "AboutCompany",
  components: {
    editor: Editor,
  },
  data() {
    return {
      companyInfosIsUpdated: false,
      snackbarFailed: false,
      snackbarFailedMessage: "",
      snackbarFailedMessage1: "",
      formFields: {
        companySize: null,
        creationDate: null,
        companyActivitySector: null,
        phoneNumber: null,
        companyName: "",
        websiteUrl: "",
        logo: null,
        backgroundPicture: null,
        description: "",
      },
      currentYear: "" + new Date().getFullYear(),
      companySizeItems: [
        "1 à 50 employés - Petite entreprise",
        "50 à 500 employés - Moyenne entreprise",
        "500 à 999 employés - Grande entreprise",
        "Plus de 1000 employés - Très grande entreprise",
      ],
      activitySectorItems: [],
      activitySectorList: [],
      currentUser: null,
      companyActivitySector: null,
      companyInformations: null,
      menu: false,
      activePicker: null,
      show1: false,
      formErrors: [],
    };
  },
  methods: {
    initializeCompanyInformationForm() {
      this.formFields.companyName = this.companyInformations.name;
      this.formFields.websiteUrl = this.companyInformations.websiteUrl;
      this.formFields.companySize = this.companyInformations.companySize;
      this.formFields.companyActivitySector = this.companyInformations.sector;
      this.formFields.creationDate =
        this.companyInformations.companyCreationDate;
      this.formFields.phoneNumber = this.companyInformations.phoneNumber;
      this.formFields.description = this.companyInformations.profileDescription;
      this.formFields.whyToApply = this.companyInformations.whyToApply;
    },

    checkForm() {
      this.formErrors = [];
      let isValid = true;

      if (
        !this.formFields.companyName ||
        this.formFields.companyName.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Le nom de l'entreprise est obligatoire.");
      }

      if (
        !this.formFields.companyActivitySector ||
        this.formFields.companyActivitySector.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push(
          "Le secteur d'activité de l'entreprise est obligatoire."
        );
      }

      if (
        this.activitySectorList.filter(
          (elt) => elt["@id"] === this.formFields.companyActivitySector
        ).length !== 1
      ) {
        isValid = false;
        this.formErrors.push("Le secteur d'activité est invalide.");
      }

      return true;
    },

    updateCompanyInfos() {
      if (this.checkForm()) {
        const company = {
          id: this.companyInformations.id,
          name: this.formFields.companyName,
          websiteUrl: this.formFields.websiteUrl,
          companySize: this.formFields.companySize,
          sector: this.formFields.companyActivitySector,
          companyCreationDate: parseInt(this.formFields.creationDate),
          phoneNumber: this.formFields.phoneNumber,
          profileDescription: this.formFields.description,
          whyToApply: this.formFields.whyToApply,
        };

        const companyLogoAndCoverPictureFormData = new FormData();
        if (this.formFields.backgroundPicture !== null) {
          companyLogoAndCoverPictureFormData.append(
            "coverPicture",
            this.formFields.backgroundPicture
          );
        }

        if (this.formFields.logo !== null) {
          companyLogoAndCoverPictureFormData.append(
            "logo",
            this.formFields.logo
          );
        }

        const httpClient = new HttpClient();
        if (
          this.formFields.logo !== null ||
          this.formFields.backgroundPicture !== null
        ) {
          httpClient
            .uploadCompanyLogoAndCoverPicture(
              companyLogoAndCoverPictureFormData,
              localStorage.getItem("jwt-token")
            )
            .then((result) => {
              // update form data
              httpClient
                .updateCompanyInformations(
                  company,
                  localStorage.getItem("jwt-token")
                )
                .then((value) => {
                  this.companyInfosIsUpdated = true;
                  this.companyInformations = value.data;
                  //this.initializeCompanyInformationForm();
                })
                .catch((reason) => {
                  if (reason.response.status === 401) {
                    this.$router.push("/logout");
                  } else {
                    this.snackbarFailed = true;
                    this.snackbarFailedMessage =
                      reason.response.data["hydra:description"];
                  }
                  this.formErrors = [];
                  this.formErrors.push("Une erreur s'est produite");
                });
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.$router.push("/logout");
              } else {
                this.snackbarFailed = true;
                this.snackbarFailedMessage1 = error.response.data;
              }
              console.error(error.response);
            });
        } else {
          httpClient
            .updateCompanyInformations(
              company,
              localStorage.getItem("jwt-token")
            )
            .then((value) => {
              this.companyInfosIsUpdated = true;
              this.companyInformations = value.data;
              //this.initializeCompanyInformationForm();
            })
            .catch((reason) => {
              if (reason.response.status === 401) {
                this.$router.push("/logout");
              } else {
                this.snackbarFailed = true;
                this.snackbarFailedMessage =
                  reason.response.data["hydra:description"];
              }
              this.formErrors = [];
              this.formErrors.push("Une erreur s'est produite");
            });
        }
      }
    },
  },
  mounted() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const httpClient = new HttpClient();
    // fetch company informations
    httpClient
      .getMyCompanyInformations(
        this.currentUser.companyManager.id,
        localStorage.getItem("jwt-token")
      )
      .then((res) => {
        this.companyInformations = res.data;
        // initialize form
        this.initializeCompanyInformationForm();
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push("/logout");
        } else if (error.response.status === 404) {
          this.$router.push({ name: "not_found" });
        } else {
          alert("Une erreur s'est produite");
        }
      });
  },
  created() {
    const httpClient = new HttpClient();
    httpClient
      .getActivitiesSectorWithOriginalApi(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.activitySectorList = value.data["hydra:member"];
        this.activitySectorList.forEach((elt) => {
          this.activitySectorItems.push({
            id: elt["@id"],
            name: elt["name"],
          });
        });
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        }
        this.formErrors.push(reason);
        console.error(reason);
      });
  },
});
</script>

<style scoped></style>
